import { createPricingBaseRequest } from "../../data/pricingBaseApi";
import { validatePricingBasePayload } from "../validator/validatePricingBasePayload";

export async function createPricingBaseUseCase(payload) {
  const error = validatePricingBasePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createPricingBaseRequest(payload);
}
